import {Box, Button, Container, Grid, TextField, Typography} from "@mui/material";
import {FeatherIcon} from "@phosphor-icons/react";
import {useContext, useState} from "react";
import {AppContext} from "../index";
import {enqueueSnackbar, SnackbarProvider} from 'notistack'
import {FunctionsError, getFunctions, httpsCallable} from "firebase/functions";

export default function Newsletter() {
    const [email, setEmail] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const app = useContext(AppContext);

    const functions = getFunctions(app);
    const signUp = httpsCallable(functions, 'signUpToNewsletter');

    return (
        <Container maxWidth={"lg"} id={"newsletter"}>
            <SnackbarProvider/>
            <Box maxWidth={"sm"} pb={24}>
                <Typography fontWeight={"bold"} variant={"h4"} paddingBottom={2}>
                    Stay up to date.
                </Typography>
                <Typography variant={"body1"} paddingBottom={2}>
                    We'll deliver updates to your inbox.
                </Typography>
                <Grid container spacing={2} direction="row">
                    <Grid size={{xs: 12, sm: 8}}>
                        <TextField variant={"filled"} label={"Email address"} fullWidth
                                   onChange={(e) => setEmail(e.target.value)}/>
                    </Grid>
                    <Grid size={{xs: 12, sm: 4}}>
                        <Button variant={"contained"} startIcon={<FeatherIcon weight={"fill"}/>}
                                sx={{height: "100%"}}
                                fullWidth disabled={isLoading} onClick={async () => {
                            if (email.length === 0) {
                                enqueueSnackbar("Please enter an email");
                                return
                            }
                            try {
                                setIsLoading(true);
                                await signUp({email: email})
                                enqueueSnackbar("Success!")
                            } catch (e) {
                                if (e instanceof FunctionsError) {
                                    enqueueSnackbar(e.message);
                                }
                            } finally {
                                setIsLoading(false);
                            }
                        }}>
                            Sign up
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
}